/**
 * @file Purchase Ppd Address Form container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import produce from 'immer';

import {
  accountAddressCreate,
  accountAddressUpdate,
} from '../../graphql/mutations/account';
import UserAddressCreateUpdate from '../../components/global/user-address/UserAddressCreateUpdate';
import { MeForPrintCheckout } from '../../graphql/queries/account';

const withAccountAddressCreate = graphql(accountAddressCreate, {
  props: ({ mutate }) => ({
    createAccountAddress: (userId, addressData) =>
      mutate({
        variables: {
          input: {
            ...addressData,
            account_id: userId,
          },
        },
        update: (store, { data: { accountAddressCreate: response } }) => {
          const data = store.readQuery({
            query: MeForPrintCheckout,
          });

          const address = response.account_address;

          const updatedData = produce(data, draft => {
            draft.me.addresses.unshift(address);
          });

          store.writeQuery({
            query: MeForPrintCheckout,
            data: updatedData,
          });
        },
      }),
  }),
});

const withAccountAddressUpdate = graphql(accountAddressUpdate, {
  props: ({ mutate }) => ({
    updateAccountAddress: addressData =>
      mutate({
        variables: {
          input: addressData,
        },
      }),
  }),
});

export default compose(
  withAccountAddressCreate,
  withAccountAddressUpdate,
)(UserAddressCreateUpdate);
